import environment from '../helpers/configEnv'

export const executeGetEndpoint = async (jwtToken, endpoint) => {
    const API_ENDPOINT = environment.apiEndpoint;
    try {
        const response = await fetch(`${API_ENDPOINT}${endpoint}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${jwtToken}`,
                'Content-Type': 'application/json',
            },
        });
        console.log(response)
        console.log('Response headers:', [...response.headers.entries()]);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error details:', {
            API_ENDPOINT,
            endpoint,
            error: error.message,
            stack: error.stack
        });
        throw error;
    }
};